import { Form, Input, Modal } from 'antd'
import { useRef, useState } from 'react'
import { displayMessage } from '../../../helpers/messages'
import api from '../../../services/api'
import { SL_ClipLoader } from '../../../components/loading/ClipLoader'

const STATUS_SUCCESS = 200

export function ModalCreateNormative({ isOpen, onClose, reloadNormatives }) {
    const formRef = useRef()

    const [loading, setLoading] = useState(false)

    const onSubmit = async normative => {
        setLoading(true)
        try {
            const response = await api.normatives.create(normative)

            if (response.status === STATUS_SUCCESS) {
                onClose(false)
                await reloadNormatives()
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            title={displayMessage('NORMATIVE_CREATION')}
            centered
            open={isOpen}
            onOk={() => formRef.current.submit()}
            confirmLoading={loading}
            onCancel={() => onClose(false)}
            okText={displayMessage('FINISH')}
            maskClosable={false}
        >
            {loading ? (
                <div className="h-screen w-full fixed top-0 left-0 flex justify-center items-center z-[9998] bg-sl-gray-500 bg-opacity-10">
                    <SL_ClipLoader loading={true} />
                </div>
            ) : (
                <Form onFinish={onSubmit} className="max-w-[700px] w-full" layout="vertical" requiredMark={false} ref={formRef}>
                    <div className="flex flex-col gap-1">
                        <div className="">{displayMessage('TITLE')}</div>

                        <Form.Item name="title" rules={[{ required: true, message: displayMessage('DISPLAY_TITLE') }]} className="mb-4">
                            <Input.TextArea autoSize={{ minRows: 2 }} placeholder={displayMessage('TITLE')} className={'w-full'} />
                        </Form.Item>
                    </div>

                    <div className="flex flex-col gap-1">
                        <div className="">{displayMessage('MODULE_DESCRIPTION')}</div>

                        <Form.Item name="description" rules={[{ required: true, message: displayMessage('DISPLAY_DESCRIPTION') }]} className="mb-4">
                            <Input.TextArea autoSize={{ minRows: 2 }} placeholder={displayMessage('MODULE_DESCRIPTION')} className={'w-full'} />
                        </Form.Item>
                    </div>
                </Form>
            )}
        </Modal>
    )
}
